import React from "react";
import { Switch, Route, useRouteMatch } from "react-router-dom";
import TitleList from "./TitleList";
import TitleCreate from "./TitleCreate";
import TitleEdit from "./TitleEdit";
import TitleDetailPage from "./TitleDetailPage";
import { RouteGuard } from "../../guards/RouteGuard";
import { RoleEnum } from "../../types/RoleEnum";
function Titles() {
    var path = useRouteMatch().path;
    var cleanPath = path.replace("/*", "");
    return (React.createElement(Switch, null,
        React.createElement(Route, { exact: true, path: cleanPath, render: function () { return (React.createElement(RouteGuard, { allowedRoles: [
                    RoleEnum.AGENCY_WORKER,
                    RoleEnum.PUBLISHER_GUARANTOR,
                    RoleEnum.PUBLISHER_ADMIN,
                    RoleEnum.DISTRIBUTOR,
                ] },
                React.createElement(TitleList, null))); } }),
        React.createElement(Route, { path: "".concat(cleanPath, "/create"), render: function () { return (React.createElement(RouteGuard, { allowedRoles: [
                    RoleEnum.AGENCY_WORKER,
                    RoleEnum.PUBLISHER_GUARANTOR,
                    RoleEnum.PUBLISHER_ADMIN,
                ] },
                React.createElement(TitleCreate, null))); } }),
        React.createElement(Route, { path: "".concat(cleanPath, "/edit/:id"), render: function () { return (React.createElement(RouteGuard, { allowedRoles: [
                    RoleEnum.AGENCY_WORKER,
                    RoleEnum.PUBLISHER_GUARANTOR,
                    RoleEnum.PUBLISHER_ADMIN,
                ] },
                React.createElement(TitleEdit, null))); } }),
        React.createElement(Route, { path: "".concat(cleanPath, "/detail"), render: function () { return (React.createElement(RouteGuard, { allowedRoles: [
                    RoleEnum.AGENCY_WORKER,
                    RoleEnum.PUBLISHER_GUARANTOR,
                    RoleEnum.PUBLISHER_ADMIN,
                    RoleEnum.DISTRIBUTOR,
                ] },
                React.createElement(TitleDetailPage, null))); } })));
}
export default Titles;
